import { render, staticRenderFns } from "./AppListNew.vue?vue&type=template&id=15418656&scoped=true"
import script from "./AppListNew.vue?vue&type=script&lang=js"
export * from "./AppListNew.vue?vue&type=script&lang=js"
import style0 from "./AppListNew.vue?vue&type=style&index=0&id=15418656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15418656",
  null
  
)

export default component.exports